import { Controller } from 'stimulus';
import $ from 'jquery';

export default class extends Controller {
    click(e) {
      e.preventDefault();

      $('#sub-nav').toggleClass('open');
    }
}